export default __webpack_public_path__ + "static/the-han-students-90858bd40adecc285d5cf150ef0625e3.jpg";